import { render, staticRenderFns } from "./ApplicationLogo.vue?vue&type=template&id=053d1eb2&scoped=true"
import script from "./ApplicationLogo.vue?vue&type=script&lang=js"
export * from "./ApplicationLogo.vue?vue&type=script&lang=js"
import style0 from "./ApplicationLogo.vue?vue&type=style&index=0&id=053d1eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d1eb2",
  null
  
)

export default component.exports